function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20409 -2012)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20409 2012)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20403.646 2018.757)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3569.871,4562.25c-.01.216-.024.376-.024.536q0,5.257,0,10.515c0,.774.2.972.983.972,2.982,0,5.966.007,8.949-.007a.894.894,0,0,1,.811.394c.445.572.971,1.08,1.481,1.632a2.547,2.547,0,0,1-.3.03h-11.052a2.788,2.788,0,0,1-2.907-2.9q-.006-6.847,0-13.693a2.85,2.85,0,0,1,3.019-3.081c.418-.008.836-.009,1.253,0,.231.006.322-.086.317-.316-.009-.462-.01-.925,0-1.388a1.023,1.023,0,0,1,1-1.1,1,1,0,0,1,1,1.087c.014.446.013.895,0,1.341-.009.262.072.374.353.373q2.886-.012,5.772,0c.28,0,.363-.122.357-.379-.01-.447-.007-.9,0-1.342a.98.98,0,0,1,1-1.079,1.023,1.023,0,0,1,1.012,1.039c.011.163,0,.327,0,.493,0,1.265,0,1.263,1.244,1.269.282,0,.564.033.846.056a2.8,2.8,0,0,1,2.506,2.835c.013.729-.018,1.462.01,2.191.017.407-.1.528-.522.527q-8.255-.022-16.511-.01Z",
  transform: "translate(3571.929 -4553.852)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-3424.292,4676.767a6.341,6.341,0,0,1-6.322-6.316,6.316,6.316,0,0,1,6.406-6.276,6.189,6.189,0,0,1,6.236,6.316A6.228,6.228,0,0,1-3424.292,4676.767Zm-.783-7.7c0,.417-.014.834,0,1.25.021.479.278.861.669.88a23.411,23.411,0,0,0,2.364,0,.684.684,0,0,0,.624-.787.69.69,0,0,0-.761-.644,8.575,8.575,0,0,0-.937,0c-.37.033-.466-.137-.456-.471.016-.52.007-1.042,0-1.563a.732.732,0,0,0-.531-.785c-.492-.145-.934.219-.97.82C-3425.094,4668.2-3425.074,4668.633-3425.075,4669.065Z",
  transform: "translate(3443.265 -4654.297)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

function SvgIconReportSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportSetting);
export default __webpack_public_path__ + "static/media/icon-report-setting.dc38db94.svg";
export { ForwardRef as ReactComponent };